export default __webpack_public_path__ + "static/media/mcgill.5a4aecba.png";